import Vue from 'vue'
import Vuex from 'vuex'
import { auth } from './auth'
import { app } from './app'
import { user } from './user'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'
export const store = new Vuex.Store({
  modules: {
    auth,
    app,
    user
  },
  strict: debug
})



// WEBPACK FOOTER //
// ./src/store/index.js